import { useMutation, useQueryClient } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { ICreateTraysData } from '../../../types';

import { TRAY_LIST_QUERY_KEY } from './useTrayListQuery';

/**
 * This is to track the create new trays mutation keys in react query cache.
 */
const MUTATE_CREATE_NEW_TRAYS = 'create-new-trays-mutation-key';

interface IUseArchiveInboundMutation {
  onSuccessCallback?: (data: ICreateTraysData) => void;
}

/**
 * This is the hook to create new trays.
 */
export const useCreateNewTraysMutation = ({
  onSuccessCallback,
}: IUseArchiveInboundMutation) => {
  const queryClient = useQueryClient();
  const { data, error, isError, isPending, mutate, reset } = useMutation({
    mutationKey: [MUTATE_CREATE_NEW_TRAYS],
    networkMode: 'always',
    mutationFn: INV_MGMT_SERVICE_API.createNewTrays,
    onSuccess: (resData) => {
      onSuccessCallback?.(resData);
      queryClient.invalidateQueries({ queryKey: [TRAY_LIST_QUERY_KEY] });
    },
  });

  return {
    data,
    error,
    isError,
    isPending,
    mutate,
    reset,
  };
};
